import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IHedefGerceklesmeOran_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IHedefGerceklesmeOran_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  SelectCurrentYear: any[];
  SelectCurrentYear_dummy: any[];
  DealerContextByKuserId: any[];
  DealerContextByKuserId_dummy: any[];
  SelectCurrentQuarter: any[];
  SelectCurrentQuarter_dummy: any[];
  SelectRolesByUserIdWithAGG: any[];
  SelectRolesByUserIdWithAGG_dummy: any[];
  DealersList: any[];
  DealersList_dummy: any[];
  sbGoalsByDealerId: any[];
  sbGoalsByDealerId_dummy: any[];
  pbGoalsProgressByDealerAndGoalId: any[];
  pbGoalsProgressByDealerAndGoalId_dummy: any[];
  pbVisGoalsProgressByDealerAndGoalId: any[];
  pbVisGoalsProgressByDealerAndGoalId_dummy: any[];
  GaolProgressByGoalId: any[];
  GaolProgressByGoalId_dummy: any[];
  pbStringGoalsProgressByDealerAndGoalId: any[];
  pbStringGoalsProgressByDealerAndGoalId_dummy: any[];
  GaolProgressStringByGoalId: any[];
  GaolProgressStringByGoalId_dummy: any[];
  isComp169323Visible: "visible" | "hidden";
  isComp382649Visible: "visible" | "hidden";
  isComp286033Visible: "visible" | "hidden";
  isComp486320Visible: "visible" | "hidden";
  isComp914409Visible: "visible" | "hidden";
  isComp500267Visible: "visible" | "hidden";
  isComp694512Visible: "visible" | "hidden";
  isComp410628Visible: "visible" | "hidden";
  isComp618572Visible: "visible" | "hidden";
  isComp996422Visible: "visible" | "hidden";
  isComp825657Visible: "visible" | "hidden";
  isComp417276Visible: "visible" | "hidden";
  isComp932681Visible: "visible" | "hidden";
  isComp998975Visible: "visible" | "hidden";
  isComp962534Visible: "visible" | "hidden";
  isComp60145Visible: "visible" | "hidden";
  isComp687057Visible: "visible" | "hidden";
  isComp133037Visible: "visible" | "hidden";
  isComp268864Visible: "visible" | "hidden";
  isComp213043Visible: "visible" | "hidden";
  isComp81701Visible: "visible" | "hidden";
  isComp250579Visible: "visible" | "hidden";
  isComp536655Visible: "visible" | "hidden";
  isComp659253Visible: "visible" | "hidden";
  isComp789483Visible: "visible" | "hidden";
  isComp984979Visible: "visible" | "hidden";
  isComp704211Visible: "visible" | "hidden";
}

export class HedefGerceklesmeOran_ScreenBase extends React.PureComponent<
  IHedefGerceklesmeOran_ScreenProps,
  any
> {
  hedefgerceklesmeoran_96121_value_kuikaSelectBoxRef: React.RefObject<any>;
  hedefgerceklesmeoran_272118_value_kuikaSelectBoxRef: React.RefObject<any>;
  hedefgerceklesmeoran_291398_value_kuikaSelectBoxRef: React.RefObject<any>;
  ml = [
    {
      Id: "f6e17cbf-9877-1e37-1dda-7f0e2f0194a4",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "58f12691-42c0-4569-8d3d-7de148711af0",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "aece693a-ad45-48b0-8aa9-a3974410166d",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 89509, PropertyName: "value", Value: "Hedef Oran" },
        { Id: 96121, PropertyName: "placeholder", Value: "Bayi seç..." },
        { Id: 272118, PropertyName: "placeholder", Value: "Hedef Seç..." },
        { Id: 291398, PropertyName: "placeholder", Value: "Çeyrek Seç..." },
        { Id: 783234, PropertyName: "placeholder", Value: "Select Year..." },
        { Id: 919678, PropertyName: "value", Value: "PowerBox Adet" },
        { Id: 299078, PropertyName: "value", Value: "Çeyrek" },
        { Id: 184846, PropertyName: "value", Value: "Yıllık" },
        { Id: 502146, PropertyName: "value", Value: "Jenerator Satış Ciro" },
        { Id: 356494, PropertyName: "value", Value: "Çeyrek" },
        { Id: 136060, PropertyName: "value", Value: "Yıllık" },
        { Id: 712966, PropertyName: "value", Value: "Dizel Adet 2" },
        { Id: 68876, PropertyName: "value", Value: "Çeyrek" },
        { Id: 864304, PropertyName: "value", Value: "Yıllık" },
        { Id: 691931, PropertyName: "value", Value: "Dizel Ciro 2" },
        { Id: 337181, PropertyName: "value", Value: "Çeyrek" },
        { Id: 27594, PropertyName: "value", Value: "Yıllık" },
        { Id: 726140, PropertyName: "value", Value: "Yedek Parça Ciro" },
        { Id: 335118, PropertyName: "value", Value: "Çeyrek" },
        { Id: 877952, PropertyName: "value", Value: "Yıllık" },
        { Id: 243660, PropertyName: "value", Value: "Yedek Parça Ciro 2" },
        { Id: 317630, PropertyName: "value", Value: "Çeyrek" },
        { Id: 436482, PropertyName: "value", Value: "Yıllık" },
        { Id: 437870, PropertyName: "value", Value: "Portatif Adet" },
        { Id: 715068, PropertyName: "value", Value: "Çeyrek" },
        { Id: 529833, PropertyName: "value", Value: "Yıllık" },
        { Id: 234840, PropertyName: "value", Value: "Portatif Ciro" },
        { Id: 248651, PropertyName: "value", Value: "Çeyrek" },
        { Id: 752277, PropertyName: "value", Value: "Yıllık" },
        { Id: 207196, PropertyName: "value", Value: "Stock" },
        { Id: 542176, PropertyName: "value", Value: "Çeyrek" },
        { Id: 345739, PropertyName: "value", Value: "Yıllık" },
        { Id: 967920, PropertyName: "value", Value: "Vade" },
        { Id: 531672, PropertyName: "value", Value: "Çeyrek" },
        { Id: 479023, PropertyName: "value", Value: "Yıllık" },
        { Id: 986681, PropertyName: "value", Value: "Pediyodik Satış" },
        { Id: 214887, PropertyName: "value", Value: "Çeyrek" },
        { Id: 314738, PropertyName: "value", Value: "Yıllık" },
        { Id: 9122, PropertyName: "value", Value: "dizel adet" },
        { Id: 59481, PropertyName: "value", Value: "yedek parça" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.hedefgerceklesmeoran_96121_value_kuikaSelectBoxRef = React.createRef();
    this.hedefgerceklesmeoran_272118_value_kuikaSelectBoxRef =
      React.createRef();
    this.hedefgerceklesmeoran_291398_value_kuikaSelectBoxRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      SelectCurrentYear: [],
      DealerContextByKuserId: [],
      SelectCurrentQuarter: [],
      SelectRolesByUserIdWithAGG: [],
      DealersList: [],
      sbGoalsByDealerId: [],
      pbGoalsProgressByDealerAndGoalId: [],
      pbVisGoalsProgressByDealerAndGoalId: [],
      GaolProgressByGoalId: [],
      pbStringGoalsProgressByDealerAndGoalId: [],
      GaolProgressStringByGoalId: [],
      dataSource_291398: [
        { key: "1", text: "1. Çeyrek" },
        { key: "2", text: "2. Çeyrek" },
        { key: "3", text: "3. Çeyrek" },
        { key: "4", text: "4. Çeyrek" },
      ],
      isComp169323Visible: "hidden",
      isComp382649Visible: "hidden",
      isComp286033Visible: "hidden",
      isComp486320Visible: "hidden",
      isComp914409Visible: "hidden",
      isComp500267Visible: "hidden",
      isComp694512Visible: "hidden",
      isComp410628Visible: "hidden",
      isComp618572Visible: "hidden",
      isComp996422Visible: "hidden",
      isComp825657Visible: "hidden",
      isComp417276Visible: "hidden",
      isComp932681Visible: "hidden",
      isComp998975Visible: "hidden",
      isComp962534Visible: "hidden",
      isComp60145Visible: "hidden",
      isComp687057Visible: "hidden",
      isComp133037Visible: "hidden",
      isComp268864Visible: "hidden",
      isComp213043Visible: "hidden",
      isComp81701Visible: "hidden",
      isComp250579Visible: "hidden",
      isComp536655Visible: "hidden",
      isComp659253Visible: "hidden",
      isComp789483Visible: "hidden",
      isComp984979Visible: "hidden",
      isComp704211Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("hedefgerceklesmeoran", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.HedefGerceklesmeOranPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("hedefgerceklesmeoran", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("hedefgerceklesmeoran", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.HedefGerceklesmeOranPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      hedefgerceklesmeoran_96121_value:
        this.props.screenInputs.DealerID ?? this.props.screenInputs.dealerid,
      hedefgerceklesmeoran_272118_value:
        this.props.screenInputs.GoalD ?? this.props.screenInputs.goald,
      hedefgerceklesmeoran_291398_value:
        this.state.SelectCurrentQuarter?.at?.(0)?.currentQuarter ?? undefined,
      hedefgerceklesmeoran_783234_value:
        this.state.SelectCurrentYear?.at?.(0)?.currentYear ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  HedefGerceklesmeOranPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      KuserID_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      UserID_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      DealerName_4: ReactSystemFunctions.convertToTypeByName("", "string"),
      Role_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectRolesByUserIdWithAGG !== undefined
            ? stateVars.SelectRolesByUserIdWithAGG?.length > 0
              ? stateVars.SelectRolesByUserIdWithAGG[0].roleNames
              : null
            : this.state.SelectRolesByUserIdWithAGG?.length > 0
            ? this.state.SelectRolesByUserIdWithAGG[0].roleNames
            : null
        ),
        "string"
      ),
      DelaerID_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.DealerContextByKuserId !== undefined
            ? stateVars.DealerContextByKuserId?.length > 0
              ? stateVars.DealerContextByKuserId[0].id
              : null
            : this.state.DealerContextByKuserId?.length > 0
            ? this.state.DealerContextByKuserId[0].id
            : null
        ),
        "Guid"
      ),
      DealerID_5: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.DealerID ?? this.props.screenInputs.dealerid,
        "Guid"
      ),
      Quarter_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectCurrentQuarter !== undefined
            ? stateVars.SelectCurrentQuarter?.length > 0
              ? stateVars.SelectCurrentQuarter[0].currentQuarter
              : null
            : this.state.SelectCurrentQuarter?.length > 0
            ? this.state.SelectCurrentQuarter[0].currentQuarter
            : null
        ),
        "number"
      ),
      GoalId_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_272118_value",
            "value",
            "sbGoalsByDealerId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      DealerID_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_96121_value",
            "value",
            "DealersList",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      ValidYear_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectCurrentYear !== undefined
            ? stateVars.SelectCurrentYear?.length > 0
              ? stateVars.SelectCurrentYear[0].currentYear
              : null
            : this.state.SelectCurrentYear?.length > 0
            ? this.state.SelectCurrentYear[0].currentYear
            : null
        ),
        "number"
      ),
      Quarter_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectCurrentQuarter !== undefined
            ? stateVars.SelectCurrentQuarter?.length > 0
              ? stateVars.SelectCurrentQuarter[0].currentQuarter
              : null
            : this.state.SelectCurrentQuarter?.length > 0
            ? this.state.SelectCurrentQuarter[0].currentQuarter
            : null
        ),
        "number"
      ),
      GoalId_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_272118_value",
            "value",
            "sbGoalsByDealerId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      DealerID_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_96121_value",
            "value",
            "DealersList",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      ValidYear_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectCurrentYear !== undefined
            ? stateVars.SelectCurrentYear?.length > 0
              ? stateVars.SelectCurrentYear[0].currentYear
              : null
            : this.state.SelectCurrentYear?.length > 0
            ? this.state.SelectCurrentYear[0].currentYear
            : null
        ),
        "number"
      ),
      GoalId_8: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.GoalD ?? this.props.screenInputs.goald,
        "Guid"
      ),
      DealerID_8: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_96121_value",
            "value",
            "DealersList",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      ValidYear_8: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectCurrentYear !== undefined
            ? stateVars.SelectCurrentYear?.length > 0
              ? stateVars.SelectCurrentYear[0].currentYear
              : null
            : this.state.SelectCurrentYear?.length > 0
            ? this.state.SelectCurrentYear[0].currentYear
            : null
        ),
        "number"
      ),
      Quarter_9: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectCurrentQuarter !== undefined
            ? stateVars.SelectCurrentQuarter?.length > 0
              ? stateVars.SelectCurrentQuarter[0].currentQuarter
              : null
            : this.state.SelectCurrentQuarter?.length > 0
            ? this.state.SelectCurrentQuarter[0].currentQuarter
            : null
        ),
        "number"
      ),
      GoalId_9: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_272118_value",
            "value",
            "sbGoalsByDealerId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      DealerID_9: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_96121_value",
            "value",
            "DealersList",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      ValidYear_9: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectCurrentYear !== undefined
            ? stateVars.SelectCurrentYear?.length > 0
              ? stateVars.SelectCurrentYear[0].currentYear
              : null
            : this.state.SelectCurrentYear?.length > 0
            ? this.state.SelectCurrentYear[0].currentYear
            : null
        ),
        "number"
      ),
      GoalId_10: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.GoalD ?? this.props.screenInputs.goald,
        "Guid"
      ),
      DealerID_10: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.DealerID ?? this.props.screenInputs.dealerid,
        "Guid"
      ),
      ValidYear_10: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectCurrentYear !== undefined
            ? stateVars.SelectCurrentYear?.length > 0
              ? stateVars.SelectCurrentYear[0].currentYear
              : null
            : this.state.SelectCurrentYear?.length > 0
            ? this.state.SelectCurrentYear[0].currentYear
            : null
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HedefGerceklesmeOran/HedefGerceklesmeOranPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectCurrentYear = result?.data.selectCurrentYear;
    formVars.hedefgerceklesmeoran_783234_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectCurrentYear !== undefined
        ? stateVars.SelectCurrentYear?.length > 0
          ? stateVars.SelectCurrentYear[0].currentYear
          : null
        : this.state.SelectCurrentYear?.length > 0
        ? this.state.SelectCurrentYear[0].currentYear
        : null
    );
    stateVars.DealerContextByKuserId = result?.data.dealerContextByKuserId;
    stateVars.SelectCurrentQuarter = result?.data.selectCurrentQuarter;
    formVars.hedefgerceklesmeoran_291398_value =
      stateVars.SelectCurrentQuarter !== undefined
        ? stateVars.SelectCurrentQuarter?.length > 0
          ? stateVars.SelectCurrentQuarter[0].currentQuarter
          : null
        : this.state.SelectCurrentQuarter?.length > 0
        ? this.state.SelectCurrentQuarter[0].currentQuarter
        : null;
    stateVars.SelectRolesByUserIdWithAGG =
      result?.data.selectRolesByUserIdWithAGG;
    stateVars.DealersList = result?.data.dealersList;

    formVars.hedefgerceklesmeoran_96121_options = stateVars.DealersList;
    stateVars.sbGoalsByDealerId = result?.data.sbGoalsByDealerId;

    formVars.hedefgerceklesmeoran_272118_options = stateVars.sbGoalsByDealerId;
    stateVars.pbGoalsProgressByDealerAndGoalId =
      result?.data.pbGoalsProgressByDealerAndGoalId;
    formVars.hedefgerceklesmeoran_646888_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity
        : null
    );
    formVars.hedefgerceklesmeoran_636457_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_789593_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity2
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity2
        : null
    );
    formVars.hedefgerceklesmeoran_993854_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover2
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover2
        : null
    );
    formVars.hedefgerceklesmeoran_556058_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_515440_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover2
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover2
        : null
    );
    formVars.hedefgerceklesmeoran_345860_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].portableQuantity
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].portableQuantity
        : null
    );
    formVars.hedefgerceklesmeoran_491093_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].portableTurnover
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].portableTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_353423_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].stock
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].stock
        : null
    );
    formVars.hedefgerceklesmeoran_774492_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].maturityPayment
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].maturityPayment
        : null
    );
    formVars.hedefgerceklesmeoran_251692_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].periodicSalesQuantity
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].periodicSalesQuantity
        : null
    );
    stateVars.pbVisGoalsProgressByDealerAndGoalId =
      result?.data.pbVisGoalsProgressByDealerAndGoalId;
    stateVars.isComp382649Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselQuantityVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselQuantityVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp286033Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp486320Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselQuantity2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselQuantity2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp914409Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp500267Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp694512Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp410628Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .portableQuantityVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .portableQuantityVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp618572Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .portableTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .portableTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp996422Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp825657Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .maturityPaymentVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .maturityPaymentVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp417276Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp998975Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselQuantityVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselQuantityVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp962534Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp60145Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselQuantity2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselQuantity2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp687057Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[
                  stateVars.pbVisGoalsProgressByDealerAndGoalId.length - 1
                ].dieselTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[
                this.state.pbVisGoalsProgressByDealerAndGoalId.length - 1
              ].dieselTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp268864Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp213043Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp81701Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .portableQuantityVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .portableQuantityVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp250579Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .portableTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .portableTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp659253Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp789483Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .maturityPaymentVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .maturityPaymentVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp984979Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp704211Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GaolProgressByGoalId = result?.data.gaolProgressByGoalId;
    formVars.hedefgerceklesmeoran_793450_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].dieselQuantityProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].dieselQuantityProgress
        : null
    );
    formVars.hedefgerceklesmeoran_134491_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].dieselTurnoverProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].dieselTurnoverProgress
        : null
    );
    formVars.hedefgerceklesmeoran_375615_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].dieselQuantity2Progress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].dieselQuantity2Progress
        : null
    );
    formVars.hedefgerceklesmeoran_849122_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].dieselTurnover2Progress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].dieselTurnover2Progress
        : null
    );
    formVars.hedefgerceklesmeoran_561917_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].sparePartTurnoverProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].sparePartTurnoverProgress
        : null
    );
    formVars.hedefgerceklesmeoran_132191_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].sparePartTurnover2Progress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].sparePartTurnover2Progress
        : null
    );
    formVars.hedefgerceklesmeoran_933292_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].portableQuantityProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].portableQuantityProgress
        : null
    );
    formVars.hedefgerceklesmeoran_297378_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].portableTurnoverProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].portableTurnoverProgress
        : null
    );
    formVars.hedefgerceklesmeoran_371665_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].stockProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].stockProgress
        : null
    );
    formVars.hedefgerceklesmeoran_641432_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].maturityPaymentProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].maturityPaymentProgress
        : null
    );
    formVars.hedefgerceklesmeoran_888578_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].periodicSalesQuantityProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].periodicSalesQuantityProgress
        : null
    );
    stateVars.pbStringGoalsProgressByDealerAndGoalId =
      result?.data.pbStringGoalsProgressByDealerAndGoalId;
    formVars.hedefgerceklesmeoran_800035_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity
        : null
    );
    formVars.hedefgerceklesmeoran_937536_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_328829_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity2
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity2
        : null
    );
    formVars.hedefgerceklesmeoran_11311_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover2
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover2
        : null
    );
    formVars.hedefgerceklesmeoran_59597_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0]
              .sparePartTurnover
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].sparePartTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_505440_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0]
              .sparePartTurnover2
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0]
            .sparePartTurnover2
        : null
    );
    formVars.hedefgerceklesmeoran_891146_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].portableQuantity
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].portableQuantity
        : null
    );
    formVars.hedefgerceklesmeoran_938492_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].portableTurnover
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].portableTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_923059_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].stock
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].stock
        : null
    );
    formVars.hedefgerceklesmeoran_710186_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].stock
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].stock
        : null
    );
    formVars.hedefgerceklesmeoran_873786_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].maturityPayment
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].maturityPayment
        : null
    );
    formVars.hedefgerceklesmeoran_593101_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0]
              .periodicSalesQuantity
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0]
            .periodicSalesQuantity
        : null
    );
    stateVars.GaolProgressStringByGoalId =
      result?.data.gaolProgressStringByGoalId;
    formVars.hedefgerceklesmeoran_312770_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].dieselQuantity
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].dieselQuantity
        : null
    );
    formVars.hedefgerceklesmeoran_628456_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].dieselTurnover
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].dieselTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_668462_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].dieselQuantity2
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].dieselQuantity2
        : null
    );
    formVars.hedefgerceklesmeoran_475039_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[
              stateVars.GaolProgressStringByGoalId.length - 1
            ].dieselTurnover2
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[
            this.state.GaolProgressStringByGoalId.length - 1
          ].dieselTurnover2
        : null
    );
    formVars.hedefgerceklesmeoran_127922_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].sparePartTurnover
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].sparePartTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_796665_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].sparePartTurnover2
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].sparePartTurnover2
        : null
    );
    formVars.hedefgerceklesmeoran_540127_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].portableQuantity
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].portableQuantity
        : null
    );
    formVars.hedefgerceklesmeoran_545019_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].portableTurnover
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].portableTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_866530_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].maturityPayment
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].maturityPayment
        : null
    );
    formVars.hedefgerceklesmeoran_180069_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].periodicSalesQuantity
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].periodicSalesQuantity
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HedefGerceklesmeOranPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HedefGerceklesmeOranPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_96121 =
      stateVars.DealersList ?? this.state.DealersList;
    stateVars.dataSource_96121 =
      stateVars.DealersList ?? this.state.DealersList;

    stateVars.dataSource_272118 =
      stateVars.sbGoalsByDealerId ?? this.state.sbGoalsByDealerId;
    stateVars.dataSource_272118 =
      stateVars.sbGoalsByDealerId ?? this.state.sbGoalsByDealerId;
    formVars.hedefgerceklesmeoran_291398_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectCurrentQuarter !== undefined
        ? stateVars.SelectCurrentQuarter?.length > 0
          ? stateVars.SelectCurrentQuarter[0].currentQuarter
          : null
        : this.state.SelectCurrentQuarter?.length > 0
        ? this.state.SelectCurrentQuarter[0].currentQuarter
        : null
    );

    formVars.hedefgerceklesmeoran_783234_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectCurrentYear !== undefined
        ? stateVars.SelectCurrentYear?.length > 0
          ? stateVars.SelectCurrentYear[0].currentYear
          : null
        : this.state.SelectCurrentYear?.length > 0
        ? this.state.SelectCurrentYear[0].currentYear
        : null
    );

    stateVars.isComp382649Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselQuantityVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselQuantityVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.hedefgerceklesmeoran_800035_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_646888_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_312770_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].dieselQuantity
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].dieselQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_793450_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].dieselQuantityProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].dieselQuantityProgress
        : null
    );

    stateVars.isComp286033Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.hedefgerceklesmeoran_937536_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_636457_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_628456_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].dieselTurnover
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].dieselTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_134491_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].dieselTurnoverProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].dieselTurnoverProgress
        : null
    );

    stateVars.isComp486320Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselQuantity2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselQuantity2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.hedefgerceklesmeoran_328829_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity2
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity2
        : null
    );

    formVars.hedefgerceklesmeoran_789593_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity2
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity2
        : null
    );

    formVars.hedefgerceklesmeoran_668462_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].dieselQuantity2
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].dieselQuantity2
        : null
    );

    formVars.hedefgerceklesmeoran_375615_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].dieselQuantity2Progress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].dieselQuantity2Progress
        : null
    );

    stateVars.isComp914409Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.hedefgerceklesmeoran_11311_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover2
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover2
        : null
    );

    formVars.hedefgerceklesmeoran_993854_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover2
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover2
        : null
    );

    formVars.hedefgerceklesmeoran_475039_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[
              stateVars.GaolProgressStringByGoalId.length - 1
            ].dieselTurnover2
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[
            this.state.GaolProgressStringByGoalId.length - 1
          ].dieselTurnover2
        : null
    );

    formVars.hedefgerceklesmeoran_849122_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].dieselTurnover2Progress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].dieselTurnover2Progress
        : null
    );

    stateVars.isComp500267Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.hedefgerceklesmeoran_59597_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0]
              .sparePartTurnover
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].sparePartTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_556058_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_127922_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].sparePartTurnover
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].sparePartTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_561917_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].sparePartTurnoverProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].sparePartTurnoverProgress
        : null
    );

    stateVars.isComp694512Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.hedefgerceklesmeoran_505440_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0]
              .sparePartTurnover2
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0]
            .sparePartTurnover2
        : null
    );

    formVars.hedefgerceklesmeoran_515440_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover2
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover2
        : null
    );

    formVars.hedefgerceklesmeoran_796665_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].sparePartTurnover2
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].sparePartTurnover2
        : null
    );

    formVars.hedefgerceklesmeoran_132191_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].sparePartTurnover2Progress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].sparePartTurnover2Progress
        : null
    );

    stateVars.isComp410628Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .portableQuantityVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .portableQuantityVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.hedefgerceklesmeoran_891146_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].portableQuantity
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].portableQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_345860_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].portableQuantity
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].portableQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_540127_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].portableQuantity
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].portableQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_933292_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].portableQuantityProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].portableQuantityProgress
        : null
    );

    stateVars.isComp618572Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .portableTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .portableTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.hedefgerceklesmeoran_938492_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].portableTurnover
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].portableTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_491093_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].portableTurnover
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].portableTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_545019_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].portableTurnover
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].portableTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_297378_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].portableTurnoverProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].portableTurnoverProgress
        : null
    );

    stateVars.isComp996422Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.hedefgerceklesmeoran_923059_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].stock
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].stock
        : null
    );

    formVars.hedefgerceklesmeoran_353423_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].stock
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].stock
        : null
    );

    formVars.hedefgerceklesmeoran_710186_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].stock
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].stock
        : null
    );

    formVars.hedefgerceklesmeoran_371665_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].stockProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].stockProgress
        : null
    );

    stateVars.isComp825657Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .maturityPaymentVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .maturityPaymentVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.hedefgerceklesmeoran_873786_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].maturityPayment
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].maturityPayment
        : null
    );

    formVars.hedefgerceklesmeoran_774492_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].maturityPayment
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].maturityPayment
        : null
    );

    formVars.hedefgerceklesmeoran_866530_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].maturityPayment
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].maturityPayment
        : null
    );

    formVars.hedefgerceklesmeoran_641432_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].maturityPaymentProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].maturityPaymentProgress
        : null
    );

    stateVars.isComp417276Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.hedefgerceklesmeoran_593101_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0]
              .periodicSalesQuantity
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0]
            .periodicSalesQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_251692_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].periodicSalesQuantity
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].periodicSalesQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_180069_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].periodicSalesQuantity
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].periodicSalesQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_888578_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].periodicSalesQuantityProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].periodicSalesQuantityProgress
        : null
    );

    stateVars.isComp998975Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselQuantityVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselQuantityVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp962534Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp60145Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselQuantity2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselQuantity2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp687057Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[
                  stateVars.pbVisGoalsProgressByDealerAndGoalId.length - 1
                ].dieselTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[
                this.state.pbVisGoalsProgressByDealerAndGoalId.length - 1
              ].dieselTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp268864Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp213043Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp81701Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .portableQuantityVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .portableQuantityVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp250579Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .portableTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .portableTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp659253Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp789483Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .maturityPaymentVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .maturityPaymentVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp984979Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp704211Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  HedefGerceklesmeOranComponent_693335_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HedefGerceklesmeOranComponent_96121_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Quarter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_291398_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      GoalId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_272118_value",
            "value",
            "sbGoalsByDealerId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      DealerID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_96121_value",
            "value",
            "DealersList",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      ValidYear_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_783234_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Quarter_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_291398_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      GoalId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_272118_value",
            "value",
            "sbGoalsByDealerId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      DealerID_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_96121_value",
            "value",
            "DealersList",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      ValidYear_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_783234_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Quarter_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_291398_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      GoalId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_272118_value",
            "value",
            "sbGoalsByDealerId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      DealerID_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_96121_value",
            "value",
            "DealersList",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      ValidYear_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_783234_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      GoalId_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_272118_value",
            "value",
            "sbGoalsByDealerId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      DealerID_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_96121_value",
            "value",
            "DealersList",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      ValidYear_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_783234_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      GoalId_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.GoalD ?? this.props.screenInputs.goald,
        "Guid"
      ),
      DealerID_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_96121_value",
            "value",
            "DealersList",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      ValidYear_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_783234_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      DealerID_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_96121_value",
            "value",
            "DealersList",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HedefGerceklesmeOran/HedefGerceklesmeOranComponent_96121_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.pbGoalsProgressByDealerAndGoalId =
      result?.data.pbGoalsProgressByDealerAndGoalId;
    formVars.hedefgerceklesmeoran_646888_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity
        : null
    );
    formVars.hedefgerceklesmeoran_636457_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_789593_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity2
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity2
        : null
    );
    formVars.hedefgerceklesmeoran_993854_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover2
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover2
        : null
    );
    formVars.hedefgerceklesmeoran_556058_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_515440_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover2
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover2
        : null
    );
    formVars.hedefgerceklesmeoran_345860_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].portableQuantity
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].portableQuantity
        : null
    );
    formVars.hedefgerceklesmeoran_491093_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].portableTurnover
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].portableTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_353423_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].stock
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].stock
        : null
    );
    formVars.hedefgerceklesmeoran_774492_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].maturityPayment
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].maturityPayment
        : null
    );
    formVars.hedefgerceklesmeoran_251692_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].periodicSalesQuantity
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].periodicSalesQuantity
        : null
    );
    stateVars.pbVisGoalsProgressByDealerAndGoalId =
      result?.data.pbVisGoalsProgressByDealerAndGoalId;
    stateVars.isComp382649Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselQuantityVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselQuantityVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp286033Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp486320Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselQuantity2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselQuantity2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp914409Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp500267Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp694512Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp410628Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .portableQuantityVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .portableQuantityVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp618572Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .portableTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .portableTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp996422Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp825657Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .maturityPaymentVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .maturityPaymentVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp417276Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp998975Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselQuantityVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselQuantityVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp962534Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp60145Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselQuantity2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselQuantity2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp687057Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[
                  stateVars.pbVisGoalsProgressByDealerAndGoalId.length - 1
                ].dieselTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[
                this.state.pbVisGoalsProgressByDealerAndGoalId.length - 1
              ].dieselTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp268864Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp213043Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp81701Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .portableQuantityVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .portableQuantityVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp250579Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .portableTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .portableTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp659253Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp789483Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .maturityPaymentVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .maturityPaymentVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp984979Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp704211Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.pbStringGoalsProgressByDealerAndGoalId =
      result?.data.pbStringGoalsProgressByDealerAndGoalId;
    formVars.hedefgerceklesmeoran_800035_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity
        : null
    );
    formVars.hedefgerceklesmeoran_937536_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_328829_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity2
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity2
        : null
    );
    formVars.hedefgerceklesmeoran_11311_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover2
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover2
        : null
    );
    formVars.hedefgerceklesmeoran_59597_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0]
              .sparePartTurnover
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].sparePartTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_505440_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0]
              .sparePartTurnover2
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0]
            .sparePartTurnover2
        : null
    );
    formVars.hedefgerceklesmeoran_891146_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].portableQuantity
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].portableQuantity
        : null
    );
    formVars.hedefgerceklesmeoran_938492_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].portableTurnover
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].portableTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_923059_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].stock
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].stock
        : null
    );
    formVars.hedefgerceklesmeoran_710186_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].stock
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].stock
        : null
    );
    formVars.hedefgerceklesmeoran_873786_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].maturityPayment
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].maturityPayment
        : null
    );
    formVars.hedefgerceklesmeoran_593101_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0]
              .periodicSalesQuantity
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0]
            .periodicSalesQuantity
        : null
    );
    stateVars.GaolProgressStringByGoalId =
      result?.data.gaolProgressStringByGoalId;
    formVars.hedefgerceklesmeoran_312770_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].dieselQuantity
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].dieselQuantity
        : null
    );
    formVars.hedefgerceklesmeoran_628456_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].dieselTurnover
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].dieselTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_668462_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].dieselQuantity2
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].dieselQuantity2
        : null
    );
    formVars.hedefgerceklesmeoran_475039_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[
              stateVars.GaolProgressStringByGoalId.length - 1
            ].dieselTurnover2
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[
            this.state.GaolProgressStringByGoalId.length - 1
          ].dieselTurnover2
        : null
    );
    formVars.hedefgerceklesmeoran_127922_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].sparePartTurnover
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].sparePartTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_796665_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].sparePartTurnover2
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].sparePartTurnover2
        : null
    );
    formVars.hedefgerceklesmeoran_540127_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].portableQuantity
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].portableQuantity
        : null
    );
    formVars.hedefgerceklesmeoran_545019_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].portableTurnover
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].portableTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_866530_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].maturityPayment
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].maturityPayment
        : null
    );
    formVars.hedefgerceklesmeoran_180069_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].periodicSalesQuantity
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].periodicSalesQuantity
        : null
    );
    stateVars.GaolProgressByGoalId = result?.data.gaolProgressByGoalId;
    formVars.hedefgerceklesmeoran_793450_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].dieselQuantityProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].dieselQuantityProgress
        : null
    );
    formVars.hedefgerceklesmeoran_134491_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].dieselTurnoverProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].dieselTurnoverProgress
        : null
    );
    formVars.hedefgerceklesmeoran_375615_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].dieselQuantity2Progress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].dieselQuantity2Progress
        : null
    );
    formVars.hedefgerceklesmeoran_849122_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].dieselTurnover2Progress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].dieselTurnover2Progress
        : null
    );
    formVars.hedefgerceklesmeoran_561917_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].sparePartTurnoverProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].sparePartTurnoverProgress
        : null
    );
    formVars.hedefgerceklesmeoran_132191_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].sparePartTurnover2Progress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].sparePartTurnover2Progress
        : null
    );
    formVars.hedefgerceklesmeoran_933292_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].portableQuantityProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].portableQuantityProgress
        : null
    );
    formVars.hedefgerceklesmeoran_297378_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].portableTurnoverProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].portableTurnoverProgress
        : null
    );
    formVars.hedefgerceklesmeoran_371665_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].stockProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].stockProgress
        : null
    );
    formVars.hedefgerceklesmeoran_641432_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].maturityPaymentProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].maturityPaymentProgress
        : null
    );
    formVars.hedefgerceklesmeoran_888578_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].periodicSalesQuantityProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].periodicSalesQuantityProgress
        : null
    );
    stateVars.sbGoalsByDealerId = result?.data.sbGoalsByDealerId;

    formVars.hedefgerceklesmeoran_272118_options = stateVars.sbGoalsByDealerId;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.HedefGerceklesmeOranComponent_96121_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HedefGerceklesmeOranComponent_96121_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_272118 =
      stateVars.sbGoalsByDealerId ?? this.state.sbGoalsByDealerId;
    stateVars.dataSource_272118 =
      stateVars.sbGoalsByDealerId ?? this.state.sbGoalsByDealerId;
    formVars.hedefgerceklesmeoran_800035_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_646888_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_312770_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].dieselQuantity
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].dieselQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_793450_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].dieselQuantityProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].dieselQuantityProgress
        : null
    );

    formVars.hedefgerceklesmeoran_937536_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_636457_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_628456_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].dieselTurnover
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].dieselTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_134491_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].dieselTurnoverProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].dieselTurnoverProgress
        : null
    );

    formVars.hedefgerceklesmeoran_328829_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity2
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity2
        : null
    );

    formVars.hedefgerceklesmeoran_789593_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity2
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity2
        : null
    );

    formVars.hedefgerceklesmeoran_668462_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].dieselQuantity2
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].dieselQuantity2
        : null
    );

    formVars.hedefgerceklesmeoran_375615_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].dieselQuantity2Progress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].dieselQuantity2Progress
        : null
    );

    formVars.hedefgerceklesmeoran_11311_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover2
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover2
        : null
    );

    formVars.hedefgerceklesmeoran_993854_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover2
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover2
        : null
    );

    formVars.hedefgerceklesmeoran_475039_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[
              stateVars.GaolProgressStringByGoalId.length - 1
            ].dieselTurnover2
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[
            this.state.GaolProgressStringByGoalId.length - 1
          ].dieselTurnover2
        : null
    );

    formVars.hedefgerceklesmeoran_849122_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].dieselTurnover2Progress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].dieselTurnover2Progress
        : null
    );

    formVars.hedefgerceklesmeoran_59597_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0]
              .sparePartTurnover
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].sparePartTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_556058_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_127922_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].sparePartTurnover
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].sparePartTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_561917_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].sparePartTurnoverProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].sparePartTurnoverProgress
        : null
    );

    formVars.hedefgerceklesmeoran_505440_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0]
              .sparePartTurnover2
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0]
            .sparePartTurnover2
        : null
    );

    formVars.hedefgerceklesmeoran_515440_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover2
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover2
        : null
    );

    formVars.hedefgerceklesmeoran_796665_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].sparePartTurnover2
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].sparePartTurnover2
        : null
    );

    formVars.hedefgerceklesmeoran_132191_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].sparePartTurnover2Progress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].sparePartTurnover2Progress
        : null
    );

    formVars.hedefgerceklesmeoran_891146_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].portableQuantity
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].portableQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_345860_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].portableQuantity
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].portableQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_540127_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].portableQuantity
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].portableQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_933292_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].portableQuantityProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].portableQuantityProgress
        : null
    );

    formVars.hedefgerceklesmeoran_938492_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].portableTurnover
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].portableTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_491093_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].portableTurnover
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].portableTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_545019_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].portableTurnover
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].portableTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_297378_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].portableTurnoverProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].portableTurnoverProgress
        : null
    );

    formVars.hedefgerceklesmeoran_923059_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].stock
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].stock
        : null
    );

    formVars.hedefgerceklesmeoran_353423_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].stock
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].stock
        : null
    );

    formVars.hedefgerceklesmeoran_710186_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].stock
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].stock
        : null
    );

    formVars.hedefgerceklesmeoran_371665_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].stockProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].stockProgress
        : null
    );

    formVars.hedefgerceklesmeoran_873786_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].maturityPayment
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].maturityPayment
        : null
    );

    formVars.hedefgerceklesmeoran_774492_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].maturityPayment
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].maturityPayment
        : null
    );

    formVars.hedefgerceklesmeoran_866530_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].maturityPayment
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].maturityPayment
        : null
    );

    formVars.hedefgerceklesmeoran_641432_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].maturityPaymentProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].maturityPaymentProgress
        : null
    );

    formVars.hedefgerceklesmeoran_593101_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0]
              .periodicSalesQuantity
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0]
            .periodicSalesQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_251692_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].periodicSalesQuantity
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].periodicSalesQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_180069_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].periodicSalesQuantity
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].periodicSalesQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_888578_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].periodicSalesQuantityProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].periodicSalesQuantityProgress
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HedefGerceklesmeOranComponent_272118_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Quarter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_291398_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      GoalId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_272118_value",
            "value",
            "sbGoalsByDealerId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      DealerID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_96121_value",
            "value",
            "DealersList",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      ValidYear_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_783234_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Quarter_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_291398_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      GoalId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_272118_value",
            "value",
            "sbGoalsByDealerId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      DealerID_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_96121_value",
            "value",
            "DealersList",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      ValidYear_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_783234_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Quarter_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_291398_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      GoalId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_272118_value",
            "value",
            "sbGoalsByDealerId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      DealerID_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_96121_value",
            "value",
            "DealersList",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      ValidYear_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_783234_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      GoalId_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_272118_value",
            "value",
            "sbGoalsByDealerId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      DealerID_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_96121_value",
            "value",
            "DealersList",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      ValidYear_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_783234_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      GoalId_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_272118_value",
            "value",
            "sbGoalsByDealerId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      DealerID_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_96121_value",
            "value",
            "DealersList",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      ValidYear_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_783234_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HedefGerceklesmeOran/HedefGerceklesmeOranComponent_272118_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.pbGoalsProgressByDealerAndGoalId =
      result?.data.pbGoalsProgressByDealerAndGoalId;
    formVars.hedefgerceklesmeoran_646888_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity
        : null
    );
    formVars.hedefgerceklesmeoran_636457_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_789593_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity2
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity2
        : null
    );
    formVars.hedefgerceklesmeoran_993854_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover2
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover2
        : null
    );
    formVars.hedefgerceklesmeoran_556058_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_515440_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover2
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover2
        : null
    );
    formVars.hedefgerceklesmeoran_345860_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].portableQuantity
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].portableQuantity
        : null
    );
    formVars.hedefgerceklesmeoran_491093_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].portableTurnover
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].portableTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_353423_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].stock
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].stock
        : null
    );
    formVars.hedefgerceklesmeoran_774492_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].maturityPayment
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].maturityPayment
        : null
    );
    formVars.hedefgerceklesmeoran_251692_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].periodicSalesQuantity
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].periodicSalesQuantity
        : null
    );
    stateVars.pbVisGoalsProgressByDealerAndGoalId =
      result?.data.pbVisGoalsProgressByDealerAndGoalId;
    stateVars.isComp382649Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselQuantityVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselQuantityVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp286033Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp486320Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselQuantity2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselQuantity2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp914409Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp500267Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp694512Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp410628Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .portableQuantityVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .portableQuantityVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp618572Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .portableTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .portableTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp996422Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp825657Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .maturityPaymentVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .maturityPaymentVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp417276Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp998975Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselQuantityVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselQuantityVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp962534Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp60145Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselQuantity2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselQuantity2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp687057Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[
                  stateVars.pbVisGoalsProgressByDealerAndGoalId.length - 1
                ].dieselTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[
                this.state.pbVisGoalsProgressByDealerAndGoalId.length - 1
              ].dieselTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp268864Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp213043Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp81701Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .portableQuantityVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .portableQuantityVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp250579Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .portableTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .portableTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp659253Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp789483Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .maturityPaymentVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .maturityPaymentVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp984979Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp704211Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.pbStringGoalsProgressByDealerAndGoalId =
      result?.data.pbStringGoalsProgressByDealerAndGoalId;
    formVars.hedefgerceklesmeoran_800035_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity
        : null
    );
    formVars.hedefgerceklesmeoran_937536_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_328829_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity2
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity2
        : null
    );
    formVars.hedefgerceklesmeoran_11311_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover2
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover2
        : null
    );
    formVars.hedefgerceklesmeoran_59597_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0]
              .sparePartTurnover
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].sparePartTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_505440_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0]
              .sparePartTurnover2
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0]
            .sparePartTurnover2
        : null
    );
    formVars.hedefgerceklesmeoran_891146_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].portableQuantity
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].portableQuantity
        : null
    );
    formVars.hedefgerceklesmeoran_938492_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].portableTurnover
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].portableTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_923059_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].stock
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].stock
        : null
    );
    formVars.hedefgerceklesmeoran_710186_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].stock
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].stock
        : null
    );
    formVars.hedefgerceklesmeoran_873786_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].maturityPayment
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].maturityPayment
        : null
    );
    formVars.hedefgerceklesmeoran_593101_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0]
              .periodicSalesQuantity
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0]
            .periodicSalesQuantity
        : null
    );
    stateVars.GaolProgressStringByGoalId =
      result?.data.gaolProgressStringByGoalId;
    formVars.hedefgerceklesmeoran_312770_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].dieselQuantity
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].dieselQuantity
        : null
    );
    formVars.hedefgerceklesmeoran_628456_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].dieselTurnover
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].dieselTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_668462_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].dieselQuantity2
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].dieselQuantity2
        : null
    );
    formVars.hedefgerceklesmeoran_475039_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[
              stateVars.GaolProgressStringByGoalId.length - 1
            ].dieselTurnover2
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[
            this.state.GaolProgressStringByGoalId.length - 1
          ].dieselTurnover2
        : null
    );
    formVars.hedefgerceklesmeoran_127922_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].sparePartTurnover
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].sparePartTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_796665_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].sparePartTurnover2
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].sparePartTurnover2
        : null
    );
    formVars.hedefgerceklesmeoran_540127_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].portableQuantity
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].portableQuantity
        : null
    );
    formVars.hedefgerceklesmeoran_545019_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].portableTurnover
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].portableTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_866530_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].maturityPayment
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].maturityPayment
        : null
    );
    formVars.hedefgerceklesmeoran_180069_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].periodicSalesQuantity
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].periodicSalesQuantity
        : null
    );
    stateVars.GaolProgressByGoalId = result?.data.gaolProgressByGoalId;
    formVars.hedefgerceklesmeoran_793450_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].dieselQuantityProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].dieselQuantityProgress
        : null
    );
    formVars.hedefgerceklesmeoran_134491_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].dieselTurnoverProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].dieselTurnoverProgress
        : null
    );
    formVars.hedefgerceklesmeoran_375615_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].dieselQuantity2Progress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].dieselQuantity2Progress
        : null
    );
    formVars.hedefgerceklesmeoran_849122_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].dieselTurnover2Progress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].dieselTurnover2Progress
        : null
    );
    formVars.hedefgerceklesmeoran_561917_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].sparePartTurnoverProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].sparePartTurnoverProgress
        : null
    );
    formVars.hedefgerceklesmeoran_132191_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].sparePartTurnover2Progress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].sparePartTurnover2Progress
        : null
    );
    formVars.hedefgerceklesmeoran_933292_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].portableQuantityProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].portableQuantityProgress
        : null
    );
    formVars.hedefgerceklesmeoran_297378_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].portableTurnoverProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].portableTurnoverProgress
        : null
    );
    formVars.hedefgerceklesmeoran_371665_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].stockProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].stockProgress
        : null
    );
    formVars.hedefgerceklesmeoran_641432_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].maturityPaymentProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].maturityPaymentProgress
        : null
    );
    formVars.hedefgerceklesmeoran_888578_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].periodicSalesQuantityProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].periodicSalesQuantityProgress
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.HedefGerceklesmeOranComponent_272118_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HedefGerceklesmeOranComponent_272118_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.hedefgerceklesmeoran_800035_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_646888_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_312770_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].dieselQuantity
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].dieselQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_793450_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].dieselQuantityProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].dieselQuantityProgress
        : null
    );

    formVars.hedefgerceklesmeoran_937536_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_636457_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_628456_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].dieselTurnover
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].dieselTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_134491_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].dieselTurnoverProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].dieselTurnoverProgress
        : null
    );

    formVars.hedefgerceklesmeoran_328829_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity2
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity2
        : null
    );

    formVars.hedefgerceklesmeoran_789593_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity2
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity2
        : null
    );

    formVars.hedefgerceklesmeoran_668462_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].dieselQuantity2
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].dieselQuantity2
        : null
    );

    formVars.hedefgerceklesmeoran_375615_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].dieselQuantity2Progress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].dieselQuantity2Progress
        : null
    );

    formVars.hedefgerceklesmeoran_11311_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover2
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover2
        : null
    );

    formVars.hedefgerceklesmeoran_993854_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover2
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover2
        : null
    );

    formVars.hedefgerceklesmeoran_475039_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[
              stateVars.GaolProgressStringByGoalId.length - 1
            ].dieselTurnover2
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[
            this.state.GaolProgressStringByGoalId.length - 1
          ].dieselTurnover2
        : null
    );

    formVars.hedefgerceklesmeoran_849122_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].dieselTurnover2Progress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].dieselTurnover2Progress
        : null
    );

    formVars.hedefgerceklesmeoran_59597_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0]
              .sparePartTurnover
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].sparePartTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_556058_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_127922_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].sparePartTurnover
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].sparePartTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_561917_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].sparePartTurnoverProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].sparePartTurnoverProgress
        : null
    );

    formVars.hedefgerceklesmeoran_505440_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0]
              .sparePartTurnover2
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0]
            .sparePartTurnover2
        : null
    );

    formVars.hedefgerceklesmeoran_515440_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover2
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover2
        : null
    );

    formVars.hedefgerceklesmeoran_796665_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].sparePartTurnover2
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].sparePartTurnover2
        : null
    );

    formVars.hedefgerceklesmeoran_132191_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].sparePartTurnover2Progress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].sparePartTurnover2Progress
        : null
    );

    formVars.hedefgerceklesmeoran_891146_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].portableQuantity
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].portableQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_345860_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].portableQuantity
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].portableQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_540127_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].portableQuantity
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].portableQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_933292_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].portableQuantityProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].portableQuantityProgress
        : null
    );

    formVars.hedefgerceklesmeoran_938492_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].portableTurnover
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].portableTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_491093_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].portableTurnover
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].portableTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_545019_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].portableTurnover
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].portableTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_297378_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].portableTurnoverProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].portableTurnoverProgress
        : null
    );

    formVars.hedefgerceklesmeoran_923059_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].stock
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].stock
        : null
    );

    formVars.hedefgerceklesmeoran_353423_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].stock
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].stock
        : null
    );

    formVars.hedefgerceklesmeoran_710186_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].stock
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].stock
        : null
    );

    formVars.hedefgerceklesmeoran_371665_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].stockProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].stockProgress
        : null
    );

    formVars.hedefgerceklesmeoran_873786_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].maturityPayment
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].maturityPayment
        : null
    );

    formVars.hedefgerceklesmeoran_774492_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].maturityPayment
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].maturityPayment
        : null
    );

    formVars.hedefgerceklesmeoran_866530_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].maturityPayment
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].maturityPayment
        : null
    );

    formVars.hedefgerceklesmeoran_641432_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].maturityPaymentProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].maturityPaymentProgress
        : null
    );

    formVars.hedefgerceklesmeoran_593101_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0]
              .periodicSalesQuantity
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0]
            .periodicSalesQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_251692_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].periodicSalesQuantity
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].periodicSalesQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_180069_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].periodicSalesQuantity
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].periodicSalesQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_888578_percent = ReactSystemFunctions.value(
      this,
      stateVars.GaolProgressByGoalId !== undefined
        ? stateVars.GaolProgressByGoalId?.length > 0
          ? stateVars.GaolProgressByGoalId[0].periodicSalesQuantityProgress
          : null
        : this.state.GaolProgressByGoalId?.length > 0
        ? this.state.GaolProgressByGoalId[0].periodicSalesQuantityProgress
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HedefGerceklesmeOranComponent_291398_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Quarter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_291398_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      GoalId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_272118_value",
            "value",
            "sbGoalsByDealerId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      DealerID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_96121_value",
            "value",
            "DealersList",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      ValidYear_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_783234_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Quarter_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_291398_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      GoalId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_272118_value",
            "value",
            "sbGoalsByDealerId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      DealerID_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_96121_value",
            "value",
            "DealersList",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      ValidYear_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_783234_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Quarter_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_291398_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      GoalId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_272118_value",
            "value",
            "sbGoalsByDealerId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      DealerID_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_96121_value",
            "value",
            "DealersList",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      ValidYear_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedefgerceklesmeoran_783234_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      GoalId_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.GoalD ?? this.props.screenInputs.goald,
        "Guid"
      ),
      DealerID_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.DealerID ?? this.props.screenInputs.dealerid,
        "Guid"
      ),
      ValidYear_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectCurrentYear !== undefined
            ? stateVars.SelectCurrentYear?.length > 0
              ? stateVars.SelectCurrentYear[0].currentYear
              : null
            : this.state.SelectCurrentYear?.length > 0
            ? this.state.SelectCurrentYear[0].currentYear
            : null
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HedefGerceklesmeOran/HedefGerceklesmeOranComponent_291398_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.pbGoalsProgressByDealerAndGoalId =
      result?.data.pbGoalsProgressByDealerAndGoalId;
    formVars.hedefgerceklesmeoran_646888_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity
        : null
    );
    formVars.hedefgerceklesmeoran_636457_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_789593_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity2
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity2
        : null
    );
    formVars.hedefgerceklesmeoran_993854_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover2
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover2
        : null
    );
    formVars.hedefgerceklesmeoran_556058_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_515440_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover2
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover2
        : null
    );
    formVars.hedefgerceklesmeoran_345860_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].portableQuantity
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].portableQuantity
        : null
    );
    formVars.hedefgerceklesmeoran_491093_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].portableTurnover
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].portableTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_353423_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].stock
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].stock
        : null
    );
    formVars.hedefgerceklesmeoran_774492_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].maturityPayment
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].maturityPayment
        : null
    );
    formVars.hedefgerceklesmeoran_251692_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].periodicSalesQuantity
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].periodicSalesQuantity
        : null
    );
    stateVars.pbVisGoalsProgressByDealerAndGoalId =
      result?.data.pbVisGoalsProgressByDealerAndGoalId;
    stateVars.isComp382649Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselQuantityVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselQuantityVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp286033Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp486320Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselQuantity2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselQuantity2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp914409Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp500267Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp694512Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp410628Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .portableQuantityVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .portableQuantityVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp618572Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .portableTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .portableTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp996422Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp825657Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .maturityPaymentVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .maturityPaymentVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp417276Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp998975Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselQuantityVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselQuantityVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp962534Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp60145Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .dieselQuantity2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .dieselQuantity2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp687057Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[
                  stateVars.pbVisGoalsProgressByDealerAndGoalId.length - 1
                ].dieselTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[
                this.state.pbVisGoalsProgressByDealerAndGoalId.length - 1
              ].dieselTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp268864Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp213043Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp81701Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .portableQuantityVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .portableQuantityVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp250579Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .portableTurnoverVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .portableTurnoverVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp659253Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp789483Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .maturityPaymentVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .maturityPaymentVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp984979Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0]
                  .sparePartTurnover2Vis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0]
                .sparePartTurnover2Vis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp704211Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.pbVisGoalsProgressByDealerAndGoalId !== undefined
            ? stateVars.pbVisGoalsProgressByDealerAndGoalId?.length > 0
              ? stateVars.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
              : null
            : this.state.pbVisGoalsProgressByDealerAndGoalId?.length > 0
            ? this.state.pbVisGoalsProgressByDealerAndGoalId[0].stockVis
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.pbStringGoalsProgressByDealerAndGoalId =
      result?.data.pbStringGoalsProgressByDealerAndGoalId;
    formVars.hedefgerceklesmeoran_800035_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity
        : null
    );
    formVars.hedefgerceklesmeoran_937536_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_328829_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity2
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity2
        : null
    );
    formVars.hedefgerceklesmeoran_11311_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover2
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover2
        : null
    );
    formVars.hedefgerceklesmeoran_59597_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0]
              .sparePartTurnover
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].sparePartTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_505440_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0]
              .sparePartTurnover2
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0]
            .sparePartTurnover2
        : null
    );
    formVars.hedefgerceklesmeoran_891146_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].portableQuantity
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].portableQuantity
        : null
    );
    formVars.hedefgerceklesmeoran_938492_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].portableTurnover
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].portableTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_923059_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].stock
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].stock
        : null
    );
    formVars.hedefgerceklesmeoran_710186_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].stock
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].stock
        : null
    );
    formVars.hedefgerceklesmeoran_873786_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].maturityPayment
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].maturityPayment
        : null
    );
    formVars.hedefgerceklesmeoran_593101_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0]
              .periodicSalesQuantity
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0]
            .periodicSalesQuantity
        : null
    );
    stateVars.GaolProgressStringByGoalId =
      result?.data.gaolProgressStringByGoalId;
    formVars.hedefgerceklesmeoran_312770_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].dieselQuantity
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].dieselQuantity
        : null
    );
    formVars.hedefgerceklesmeoran_628456_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].dieselTurnover
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].dieselTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_668462_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].dieselQuantity2
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].dieselQuantity2
        : null
    );
    formVars.hedefgerceklesmeoran_475039_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[
              stateVars.GaolProgressStringByGoalId.length - 1
            ].dieselTurnover2
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[
            this.state.GaolProgressStringByGoalId.length - 1
          ].dieselTurnover2
        : null
    );
    formVars.hedefgerceklesmeoran_127922_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].sparePartTurnover
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].sparePartTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_796665_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].sparePartTurnover2
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].sparePartTurnover2
        : null
    );
    formVars.hedefgerceklesmeoran_540127_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].portableQuantity
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].portableQuantity
        : null
    );
    formVars.hedefgerceklesmeoran_545019_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].portableTurnover
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].portableTurnover
        : null
    );
    formVars.hedefgerceklesmeoran_866530_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].maturityPayment
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].maturityPayment
        : null
    );
    formVars.hedefgerceklesmeoran_180069_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].periodicSalesQuantity
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].periodicSalesQuantity
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.HedefGerceklesmeOranComponent_291398_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HedefGerceklesmeOranComponent_291398_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.hedefgerceklesmeoran_800035_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_646888_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_312770_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].dieselQuantity
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].dieselQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_937536_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_636457_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_628456_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].dieselTurnover
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].dieselTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_328829_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity2
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselQuantity2
        : null
    );

    formVars.hedefgerceklesmeoran_789593_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity2
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselQuantity2
        : null
    );

    formVars.hedefgerceklesmeoran_668462_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].dieselQuantity2
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].dieselQuantity2
        : null
    );

    formVars.hedefgerceklesmeoran_11311_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover2
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].dieselTurnover2
        : null
    );

    formVars.hedefgerceklesmeoran_993854_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover2
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].dieselTurnover2
        : null
    );

    formVars.hedefgerceklesmeoran_475039_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[
              stateVars.GaolProgressStringByGoalId.length - 1
            ].dieselTurnover2
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[
            this.state.GaolProgressStringByGoalId.length - 1
          ].dieselTurnover2
        : null
    );

    formVars.hedefgerceklesmeoran_59597_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0]
              .sparePartTurnover
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].sparePartTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_556058_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_127922_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].sparePartTurnover
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].sparePartTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_505440_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0]
              .sparePartTurnover2
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0]
            .sparePartTurnover2
        : null
    );

    formVars.hedefgerceklesmeoran_515440_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover2
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].sparePartTurnover2
        : null
    );

    formVars.hedefgerceklesmeoran_796665_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].sparePartTurnover2
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].sparePartTurnover2
        : null
    );

    formVars.hedefgerceklesmeoran_891146_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].portableQuantity
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].portableQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_345860_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].portableQuantity
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].portableQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_540127_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].portableQuantity
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].portableQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_938492_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].portableTurnover
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].portableTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_491093_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].portableTurnover
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].portableTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_545019_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].portableTurnover
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].portableTurnover
        : null
    );

    formVars.hedefgerceklesmeoran_923059_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].stock
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].stock
        : null
    );

    formVars.hedefgerceklesmeoran_353423_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].stock
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].stock
        : null
    );

    formVars.hedefgerceklesmeoran_710186_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].stock
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].stock
        : null
    );

    formVars.hedefgerceklesmeoran_873786_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0].maturityPayment
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0].maturityPayment
        : null
    );

    formVars.hedefgerceklesmeoran_774492_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].maturityPayment
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].maturityPayment
        : null
    );

    formVars.hedefgerceklesmeoran_866530_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].maturityPayment
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].maturityPayment
        : null
    );

    formVars.hedefgerceklesmeoran_593101_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbStringGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbStringGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbStringGoalsProgressByDealerAndGoalId[0]
              .periodicSalesQuantity
          : null
        : this.state.pbStringGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbStringGoalsProgressByDealerAndGoalId[0]
            .periodicSalesQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_251692_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbGoalsProgressByDealerAndGoalId !== undefined
        ? stateVars.pbGoalsProgressByDealerAndGoalId?.length > 0
          ? stateVars.pbGoalsProgressByDealerAndGoalId[0].periodicSalesQuantity
          : null
        : this.state.pbGoalsProgressByDealerAndGoalId?.length > 0
        ? this.state.pbGoalsProgressByDealerAndGoalId[0].periodicSalesQuantity
        : null
    );

    formVars.hedefgerceklesmeoran_180069_value = ReactSystemFunctions.toString(
      this,
      stateVars.GaolProgressStringByGoalId !== undefined
        ? stateVars.GaolProgressStringByGoalId?.length > 0
          ? stateVars.GaolProgressStringByGoalId[0].periodicSalesQuantity
          : null
        : this.state.GaolProgressStringByGoalId?.length > 0
        ? this.state.GaolProgressStringByGoalId[0].periodicSalesQuantity
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.HedefGerceklesmeOranPageInit();
    }
  }
}
